import {shallowEqual} from 'react-redux';
import {useAppSelector} from 'store/hooks';
import type {EntityEditStatus} from '../types';
import {selectMetadataEditEditStatuses} from '../metadataEditSlice';

const DEFAULT_EDIT_STATUS: EntityEditStatus = {
  hasDataChanged: false,
  hasMoved: false,
};

export const useEditStatus = (id: string): EntityEditStatus => {
  const status = useAppSelector(
    state => selectMetadataEditEditStatuses(state)[id],
    shallowEqual,
  );
  return status ?? DEFAULT_EDIT_STATUS;
};
